module.exports = __webpack_public_path__ + "img/3.115b5183.png";